import React from 'react'
import styled, { css } from 'styled-components'

import { colors } from '@/config/global-parameters'

interface ILiveIndicator {
  animated?: boolean
  centered?: boolean
  className?: string
  handleClick?: () => void
  queryName?: string
  active?: boolean
}

const LiveIndicator = ({
  active = true,
  animated = true,
  centered = true,
  className,
  handleClick,
  queryName = 'small',
}: ILiveIndicator) => {
  const isMobileDevice = ['small', 'phone'].includes(queryName)
  return (
    <Container
      className={className}
      onClick={handleClick}
      smallDevice={centered}
    >
      <LiveCircle
        active={active}
        animated={animated}
        smallDevice={isMobileDevice}
      />
      <VideoTitle smallDevice={isMobileDevice}>LIVE</VideoTitle>
    </Container>
  )
}

const VideoTitle = styled.div<{ smallDevice: boolean }>`
  padding-left: 8px;
  font-weight: ${(props) => (props.smallDevice ? 700 : 500)};
  line-height: 21px;
  text-align: center;
  color: ${colors.colorRed1};
  cursor: ${(props) => (props.smallDevice ? 'pointer' : 'default')};
`

const Container = styled.div<{ smallDevice: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.smallDevice ? 'center' : 'left')};
`

const animationLive = css`
  @keyframes live {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  animation-name: live;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
`
const LiveCircle = styled.div<{ active: boolean; smallDevice: boolean; animated: boolean }>`
  background-color: ${({ active }) => (active ? 'red' : 'grey')};
  border-radius: 50%;
  text-align: center;
  width: ${({ smallDevice }) => (smallDevice ? 8 : 10)}px;
  height: ${({ smallDevice }) => (smallDevice ? 8 : 10)}px;
  ${({ active, animated }) => animated && active && animationLive}
`

export default LiveIndicator
